import { render, staticRenderFns } from "./CredentialDetails.vue?vue&type=template&id=45e59cc8"
import script from "./CredentialDetails.vue?vue&type=script&lang=js"
export * from "./CredentialDetails.vue?vue&type=script&lang=js"
import style0 from "./CredentialDetails.vue?vue&type=style&index=0&id=45e59cc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports